import { Component } from 'react'
import * as styles from 'components/features/socialFeed/FeedPost/FetchedLink.styl'
import * as cn from 'classnames'
import { MediaLink, ImageURLs } from 'interfaces/media'
import VideoPlayer from 'components/features/pfm/VideoPlayer/VideoPlayer'
import AdjustableImage from 'components/features/pfm/AdjustableImage/AdjustableImage'

type FetchedLinkProps =
  & MediaLink
  & {
    className?: string
    compact?: boolean
  }

export class FetchedLink extends Component<FetchedLinkProps> {
  static defaultProps: Partial<FetchedLinkProps> = {
    image: null,
  }

  private get containerClassName () {
    const {
      className,
      compact,
    } = this.props

    return cn(
      styles.container,
      {
        [styles.compact]: compact,
      },
      className
    )
  }

  render () {
    const { compact, player, image, url } = this.props
    if (player && !compact) {
      return this.renderVideo(url, image)
    }

    return this.renderSite(url, image)
  }

  private renderVideo (url: string, image: ImageURLs | null) {
    return (
      <div className={ this.containerClassName }>
        <div className={ styles.video }>
          <VideoPlayer
            poster={ image }
            videoUrl={ url }
          />
        </div>
        { this.renderInfo() }
      </div>
    )
  }

  private renderSite (url: string, image: ImageURLs | null) {
    return (
      <a
        className={ this.containerClassName }
        href={ url }
        target='_blank'
      >
        { image &&
          <div className={ styles.image }>
            <AdjustableImage image={ image } />
          </div>}
        { this.renderInfo() }
      </a>
    )
  }

  private renderInfo () {
    const {
      title,
      description,
      site_name,
    } = this.props
    return (
      <div className={ styles.info }>
        { site_name &&
          <div className={ styles.domain }>{ site_name }</div>}
        { title &&
          <div className={ styles.title }>{ title }</div>}
        { description &&
          <div className={ styles.subtitle }>{ description }</div>}
      </div>
    )
  }

}
